export const getTagStyles = (type: 'level' | 'progress' = 'level') => {
  const baseStyles = {
    rounded: "xl",
    width: "fit-content",
    fontSize: "var(--base-font-size-xs)",
    fontWeight: "semibold",
  };

  switch (type) {
    case 'progress':
      return {
        ...baseStyles,
        bg: "var(--color-green)",
        color: "white",
        py: "5px",
        px: "8px",
        justifyContent: "center",
        alignItems: "center",
      };
    case 'level':
      return {
        ...baseStyles,
        bg: "transparent",
        p: 0,
      };
    default:
      return baseStyles;
  }
};
